import React, { FC } from 'react';
import { StyleSheet, View, ViewProps, useWindowDimensions } from 'react-native';
import { color, spacing } from '../../../theme';
import { Button } from '../../Button/Button';

import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { ScrollView } from 'react-native-gesture-handler';
import { EmojiWithBackground } from '../../EmojiWithBackground/EmojiWithBackground';

interface Props extends ViewProps {
  emoji?: string;
  onDismiss: () => void;
}

const NotificationModalContainer: FC<Props> = (props) => {
  const { width } = useWindowDimensions();
  return (
    <ScrollView>
      <View
        style={{
          flexDirection: width < 500 ? 'column' : 'row',
          gap: spacing[1],
        }}
      >
        <EmojiWithBackground style={{}} emoji={props.emoji || '🔔'} />
        <View style={styles.main}>
          <View style={styles.header}>
            <View style={styles.headerDetails}>{props.children}</View>
          </View>
        </View>

        <Button
          style={{ position: 'absolute', top: 0, right: 0 }}
          preset="tertiary"
          onPress={props.onDismiss}
        >
          <FontAwesomeIcon
            size={20}
            icon="times"
            style={styles.closeButtonIcon}
          />
        </Button>
      </View>
    </ScrollView>
  );
};

// Styles
const styles = StyleSheet.create({
  closeButtonIcon: {
    color: color.primary,
  },
  header: {
    flexDirection: 'row',
  },
  headerDetails: {
    flex: 1,
  },
  main: {
    flex: 1,
    marginLeft: spacing[2],
  },
});

export default NotificationModalContainer;
